export default class CountryState {
  public stateName: string = "";
  public stateShortName: string = "";
  public displayName = () => `${this.stateName} (${this.stateShortName})`;
}
